"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ErrorText = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ErrorText = function ErrorText(props) {
  var classNames = props.classNames,
      children = props.children;
  return /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)('kubra-ux-error-text', classNames)
  }, children);
};

exports.ErrorText = ErrorText;
ErrorText.propTypes = {
  classNames: _propTypes.default.any.isRequired,
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.oneOf([null])])
};
var defaultProps = {
  classNames: {},
  children: null
};
ErrorText.defaultProps = defaultProps;
var _default = ErrorText;
exports.default = _default;